<div
  class="full-page w-100 d-flex px-0"
  [style.background-image]="'url(' + ('login-registration/login-background.jpg' | contentAssetImage) + ')'"
>
  <!--Left Side-->
  <div class="container">
    <img [src]="'logos/rewards-logo.png' | contentAssetImage" alt="" class="logo" />
    <!--Right Side-->
    <div class="right-side-maintenance">
      <span class="icon logo-maintenance material-symbols-outlined">engineering</span>
      <h4 class="title-maintenance panel-text font-size-20 fw-bold mb-0">
        {{ 'maintenance.page.title' | translate }}
      </h4>
      <div class="font-size-14 text-start description-two text-center">
        {{ 'maintenance.page.description' | translate }}
      </div>
    </div>
  </div>
</div>
